import React from 'react';
import type {RuleConditionState} from '../../../modules/ruleengine/types';
import {COUNTER_TRIGGER_MIN_VALUE, COUNTER_TRIGGER_MAX_VALUE} from '../../../modules/ruleengine/config/consts';
type Props = {
	disabled: boolean;
	onChange: (arg0: Partial<RuleConditionState>) => void;
	value?: number;
};

const TriggerOptionalSettingsCounterInput = ({disabled, value, onChange}: Props) => {
	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const {value} = event.target;
		onChange({
			counter: {
				conditionCount: parseInt(value, 10) || undefined
			},
			duration: undefined
		});
	};

	return (
		<input
			data-testid="optional-setting-value"
			type="number"
			disabled={disabled}
			min={COUNTER_TRIGGER_MIN_VALUE}
			max={Math.floor(COUNTER_TRIGGER_MAX_VALUE)}
			value={value || ''}
			onChange={handleChange}
		/>
	);
};

export default TriggerOptionalSettingsCounterInput;
